import { state, props, resolveObject } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import unsetSelectedFilesInView from '../actions/unsetSelectedFilesInView'
import setDeletedAtForSelectedFiles from '../factories/setDeletedAtForSelectedFiles'
import deselectAllFiles from './deselectAllFiles'
import createSnackbar from 'modules/App/factories/createSnackbar'

export default [
  set(state`media.filesToDelete`, state`media.selectedFiles`),
  unsetSelectedFilesInView,
  ...deselectAllFiles,
  function({ state }) {
    return {
      count: state.get('media.filesToDelete').length
    }
  },
  setDeletedAtForSelectedFiles(true),
  createSnackbar(
    resolveObject({
      key: 'bms.media.deletedFiles',
      params: resolveObject({ count: props`count` })
    })
  ),
  set(state`media.filesToDelete`, [])
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onDeleteSelectedFiles.js